export const SET_CHALLENGE = "SET_CHALLENGE"
export const SET_CUID_STATUS_CHALLENGE = "SET_CUID_STATUS_CHALLENGE"
export const SET_GUESS_CHALLENGE = "SET_GUESS_CHALLENGE"